module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dqrNW"))).then(() => parcelRequire('5erN3'));